import React, { useEffect, useState } from "react";
import { getFromLocalStorage } from "../../../../../utils/common-utils";
import {
  CreateNewService,
  envStatusChange,
  GetContentProviderData,
  GetCountries,
  UpdateService,
} from "../../../../../api/Api";
import Swal from "sweetalert2";
import "./editService.css";

const EditService = ({
  setEditCpModal,
  getAllData,
  getCount,
  cp,
  editData,
}) => {
  const [createUserForm, setCreateUserForm] = useState({
    contentPartner: editData?.cpName || "",
    country: editData?.countryName || "",
    operator: editData?.operatorName || "",
    environmentStatus: editData?.testBed || "",
    production: editData?.production || "",
    serviceType: editData?.serviceType || "",
    serviceName: editData?.serviceName || "",
    serviceNameArabic: editData?.serviceNameArabic || "",
    portalLink: editData?.portalAndAppLink || "",
    serviceDescription: editData?.serviceDescription || "",
    serviceDescriptionArabic: editData?.serviceArabicDescription || "",
    operatorShare: editData?.operatorShare || "0",
    aggregateShare: editData?.aggregatorShare || "0",
    partnerShare: editData?.partnerShare || "0",
  });
  const [error, setError] = useState(false);
  const [loaders, setLoaders] = useState({
    cpLoader: false,
    countryLoader: false,
  });
  const [cpList, setCpList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [isProduction, setIsProduction] = useState(true);

  const isValidURL = (url) => {
    const regex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,6})([/\w .-]*)*\/?$/i;
    return regex.test(url);
  };

  console.log("editDatacp", editData);
  // create User
  const handleSubmit = async (e) => {
    e.preventDefault();
    const {
      contentPartner,
      country,
      operator,
      serviceType,
      serviceName,
      serviceNameArabic,
      portalLink,
      serviceDescription,
      serviceDescriptionArabic,
      operatorShare,
      aggregateShare,
      partnerShare,
    } = createUserForm;
    const sharesSum =
      Number(operatorShare) + Number(aggregateShare) + Number(partnerShare);
    if (
      //   !contentPartner ||
      //   !country ||
      //   !operator ||
      !serviceType ||
      //   !serviceName ||
      //   !serviceNameArabic ||
      !portalLink ||
      !isValidURL(portalLink) ||
      !serviceDescription ||
      !serviceDescriptionArabic ||
      !operatorShare ||
      (operatorShare && Number(operatorShare) > 100) ||
      !aggregateShare ||
      (aggregateShare && Number(aggregateShare) > 100) ||
      !partnerShare ||
      (partnerShare && Number(partnerShare) > 100)
    ) {
      setError(true);
    } else if (sharesSum !== 100) {
      Swal.fire({
        title: "Invalid Shares",
        text: `The sum of Operator Share (${operatorShare}%), Aggregate Share (${aggregateShare}%), and Partner Share (${partnerShare}%) must equal 100%. Current sum: ${sharesSum}%`,
        icon: "info",
        button: "OK",
      });
    } else {
      setError(false);
      let payload = {
        userId: getFromLocalStorage("userData")?.id,
        id: editData?.id,
        serviceName: null,
        serviceType: serviceType,
        portalAndAppLink: portalLink,
        serviceDescription: serviceDescription,
        serviceArabicDescription: serviceDescriptionArabic,
        serviceNameArabic: null,
        aggregatorShare: Number(aggregateShare),
        partnerShare: Number(partnerShare),
        operatorShare: Number(operatorShare),
      };
      console.log("payload", payload);
      const response = await UpdateService(payload);
      console.log("responseCreateUser", response);
      if (response?.statusDescription?.status == 200) {
        if (cp) {
          getAllData();
          getCount();
        }
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
        setEditCpModal(false);
      } else {
        Swal.fire({
          icon: "info",
          text: response?.statusDescription?.description,
          confirmButtonText: "OK",
        });
      }
    }
  };

  const getCpList = async () => {
    setLoaders((prev) => ({ ...prev, cpLoader: true }));
    let payload = {
      pageNo: 0,
      pageSize: 1000,
      userId: getFromLocalStorage("userData")?.id,
      status: 1,
    };
    const response = await GetContentProviderData(payload);
    console.log("resFetchBU", response);
    setLoaders((prev) => ({ ...prev, cpLoader: false }));
    if (response?.statusDescription?.status == 200) {
      setCpList(response?.userListPage?.content);
    } else {
      setCpList([]);
    }
  };
  const envStatusChangefun = async (newStatus) => {
    try {
      Swal.fire({
        title: 'Are you sure?',
        text: `Do you want to switch to ${newStatus ? 'Production' : 'TestBed'} environment?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          try {
            setLoaders((prev) => ({ ...prev, cpLoader: true }));

            const payload = {
              userId: getFromLocalStorage("userData")?.id,
              serviceId: editData?.id,
              testBed: !newStatus,
              production: newStatus
            };

            const response = await envStatusChange(payload);
            setLoaders((prev) => ({ ...prev, cpLoader: false }));

            if (response?.statusDescription?.status === 200) {
              setIsProduction(newStatus);
              getAllData();
              getCount();
              return response;
            } else {
              throw new Error(response?.statusDescription?.description || 'Failed to update environment');
            }
          } catch (error) {
            throw new Error(error.message || 'Failed to update environment');
          }
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            'Success!',
            `Environment switched to ${newStatus ? 'Production' : 'TestBed'}`,
            'success'
          );
        }
      });
    } catch (error) {
      console.error('Error:', error);
      Swal.fire('Error!', error.message, 'error');
    }
  };

  const getCountriesAndOperators = async () => {
    setLoaders((prev) => ({ ...prev, countryLoader: true }));
    const response = await GetCountries();
    if (response?.statusDescription?.status == 200) {
      setCountryList(response?.countryResponseList);
    } else {
      setCountryList([]);
    }
    setLoaders((prev) => ({ ...prev, countryLoader: false }));
  };

  useEffect(() => {
    getCountriesAndOperators();
  }, []);

  useEffect(() => {
    getCpList();
  }, []);
  useEffect(() => {
    if (editData) {
      setIsProduction(editData.isProduction);
    }
  }, [editData]);



  return (
    <form class="form-horizontal px-md-0 px-3" onSubmit={handleSubmit}>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label class="">
              Content Provider <sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class="form-control"
              name="contentPartner"
              maxLength={50}
              value={createUserForm.contentPartner || ""}
              readOnly
              disabled
            />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label class="">
              Country <sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class="form-control"
              name="country"
              maxLength={50}
              value={createUserForm.country || ""}
              readOnly
              disabled
            />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label class="">
              Select Operator <sup class="text-danger">*</sup>
            </label>
            <input
              type="text"
              class="form-control"
              name="operator"
              value={createUserForm.operator || ""}
              readOnly
              disabled
            />
          </div>
        </div>

        {createUserForm?.contentPartner &&
          createUserForm?.country &&
          createUserForm?.operator && (
            <>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Select Service Type <sup class="text-danger">*</sup>
                  </label>
                  <div className="position-relative">
                    <select
                      class={`form-control ${error && !createUserForm.serviceType ? "is-invalid" : ""
                        }`}
                      name="serviceType"
                      formControlName="serviceType"
                      value={createUserForm.serviceType}
                      onChange={(e) =>
                        setCreateUserForm({
                          ...createUserForm,
                          serviceType: e.target.value,
                        })
                      }
                    >
                      <option value="" selected>
                        --Select Service Type --
                      </option>
                      <option value="Charity">Charity</option>
                      <option value="Normal">Normal</option>
                    </select>
                    <div className="dropdown-icon">
                      <i
                        className="fas fa-chevron-down"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                          display: loaders.countryLoader ? "none" : "block",
                        }}
                      ></i>
                    </div>
                  </div>
                  {error && !createUserForm.serviceType && (
                    <span class="invalid-feedback d-block error">
                      Service Type is required
                    </span>
                  )}
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Service Name <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    name="serviceName"
                    value={createUserForm.serviceName || ""}
                    readOnly
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Service Name Arabic <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    maxLength={50}
                    name="serviceNameArabic"
                    value={createUserForm.serviceNameArabic || ""}
                    readOnly
                    disabled
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Portal Link <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    class={`form-control ${error &&
                      (!createUserForm.portalLink ||
                        !isValidURL(createUserForm.portalLink))
                      ? "is-invalid"
                      : ""
                      }`}
                    name="portalLink"
                    maxLength={100}
                    formControlName="portalLink"
                    placeholder="Enter Portal Link"
                    value={createUserForm.portalLink}
                    onChange={(e) =>
                      setCreateUserForm({
                        ...createUserForm,
                        portalLink: e.target.value,
                      })
                    }
                  />
                  {error &&
                    (!createUserForm.portalLink ||
                      !isValidURL(createUserForm.portalLink)) && (
                      <span class="invalid-feedback d-block error">
                        {error && !createUserForm.portalLink
                          ? "Portal Link is required"
                          : !isValidURL(createUserForm.portalLink)
                            ? "Invalid URL format"
                            : ""}
                      </span>
                    )}
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Operator Share <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    class={`form-control ${error &&
                      (!createUserForm.operatorShare ||
                        Number(createUserForm.operatorShare) > 100)
                      ? "is-invalid"
                      : ""
                      }`}
                    name="operatorShare"
                    formControlName="operatorShare"
                    placeholder="Enter Operator Share"
                    maxLength={3}
                    value={createUserForm.operatorShare}
                    onChange={(e) =>
                      setCreateUserForm({
                        ...createUserForm,
                        operatorShare: e.target.value,
                      })
                    }
                    onKeyPress={(e) => {
                      if (
                        /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(
                          e.key
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {error &&
                    (!createUserForm.operatorShare ||
                      Number(createUserForm.operatorShare) > 100) && (
                      <span class="invalid-feedback d-block error">
                        {!createUserForm.operatorShare
                          ? "Operator Share is required"
                          : createUserForm.operatorShare &&
                            Number(createUserForm.operatorShare) > 100
                            ? "Operator Share must be less than 100"
                            : ""}
                      </span>
                    )}
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Aggregate Share <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    class={`form-control ${error &&
                      (!createUserForm.aggregateShare ||
                        Number(createUserForm.aggregateShare) > 100)
                      ? "is-invalid"
                      : ""
                      }`}
                    name="aggregateShare"
                    formControlName="aggregateShare"
                    placeholder="Enter Aggregate Share"
                    maxLength={3}
                    value={createUserForm.aggregateShare}
                    onChange={(e) =>
                      setCreateUserForm({
                        ...createUserForm,
                        aggregateShare: e.target.value,
                      })
                    }
                    onKeyPress={(e) => {
                      if (
                        /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(
                          e.key
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {error &&
                    (!createUserForm.aggregateShare ||
                      Number(createUserForm.aggregateShare) > 100) && (
                      <span class="invalid-feedback d-block error">
                        {!createUserForm.aggregateShare
                          ? "Aggregate Share is required"
                          : createUserForm.aggregateShare &&
                            Number(createUserForm.aggregateShare) > 100
                            ? "Aggregate Share must be less than 100"
                            : ""}
                      </span>
                    )}
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Partner Share <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    class={`form-control ${error &&
                      (!createUserForm.partnerShare ||
                        Number(createUserForm.partnerShare) > 100)
                      ? "is-invalid"
                      : ""
                      }`}
                    name="partnerShare"
                    formControlName="partnerShare"
                    placeholder="Enter Partner Share"
                    maxLength={3}
                    value={createUserForm.partnerShare}
                    onChange={(e) =>
                      setCreateUserForm({
                        ...createUserForm,
                        partnerShare: e.target.value,
                      })
                    }
                    onKeyPress={(e) => {
                      if (
                        /^[a-zA-Z\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/.test(
                          e.key
                        )
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                  {error &&
                    (!createUserForm.partnerShare ||
                      Number(createUserForm.partnerShare) > 100) && (
                      <span class="invalid-feedback d-block error">
                        {!createUserForm.partnerShare
                          ? "Partner Share is required"
                          : createUserForm.partnerShare &&
                            Number(createUserForm.partnerShare) > 100
                            ? "Partner Share must be less than 100"
                            : ""}
                      </span>
                    )}
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Service Description <sup class="text-danger">*</sup>
                  </label>
                  <textarea
                    class={`form-control ${error && !createUserForm.serviceDescription
                      ? "is-invalid"
                      : ""
                      }`}
                    name="serviceDescription"
                    maxLength={200}
                    formControlName="serviceDescription"
                    placeholder="Enter Service Description"
                    value={createUserForm.serviceDescription}
                    onChange={(e) =>
                      setCreateUserForm({
                        ...createUserForm,
                        serviceDescription: e.target.value,
                      })
                    }
                    rows="3"
                  ></textarea>
                  {error && !createUserForm.serviceDescription && (
                    <span class="invalid-feedback d-block error">
                      Service Description is required
                    </span>
                  )}
                </div>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label class="">
                    Service Description Arabic <sup class="text-danger">*</sup>
                  </label>
                  <textarea
                    class={`form-control ${error && !createUserForm.serviceDescriptionArabic
                      ? "is-invalid"
                      : ""
                      }`}
                    name="serviceDescriptionArabic"
                    maxLength={200}
                    formControlName="serviceDescriptionArabic"
                    placeholder="Enter Service Description Arabic"
                    value={createUserForm.serviceDescriptionArabic}
                    onChange={(e) =>
                      setCreateUserForm({
                        ...createUserForm,
                        serviceDescriptionArabic: e.target.value,
                      })
                    }
                    rows="3"
                  ></textarea>
                  {error && !createUserForm.serviceDescriptionArabic && (
                    <span class="invalid-feedback d-block error">
                      Service Description Arabic is required
                    </span>
                  )}
                </div>
              </div>
              {console.log("isProduction", isProduction, editData)}
              <div className="environment-toggle">
                <div className="d-flex align-items-center justify-content-start mb-3" style={{paddingLeft: "10px"}}>
                  <span className={`mr-2 ${!isProduction ? 'text-primary' : 'text-muted'} style={{fontSize: "14px"}}`}>TestBed</span>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={isProduction}
                      onChange={() => envStatusChangefun(!isProduction)}
                      disabled={loaders.cpLoader}
                    />
                    <span className="slider round mt-2" id="slide_edit"> </span>
                  </label>
                  <span className={`ml-2 ${isProduction ? 'text-primary' : 'text-muted'}`}>Production</span>
                </div>
              </div>
            </>
          )}
      </div>
      <div class="modal-footer pb-0 border-0 d-flex justify-content-between mx-0 px-0  buttons_divs">
        <button
          type="button"
          class="btn btn-danger m-0"
          data-dismiss="modal"
          onClick={() => {
            setEditCpModal(false);
            setError(false);
          }}
        >
          Cancel
        </button>
        <button type="submit" class="btn btn-primary m-0">
          Submit
        </button>
      </div>
    </form>
  );
};

export default EditService;
